import { Flex } from "@chakra-ui/react";

function TableHeaderRow() {
  return (
    <>
      <Flex flex={2} ml={4}>
        Categoria
      </Flex>
      <Flex flex={1} justifyContent="flex-end" textAlign="right">
        Valor Original
      </Flex>
      <Flex flex={1} justifyContent="flex-end" textAlign="right">
        Multa
      </Flex>
      <Flex flex={1} justifyContent="flex-end" textAlign="right">
        Juros
      </Flex>
      <Flex flex={1} justifyContent="flex-end" textAlign="right">
        Tx. Cobrança
      </Flex>
      <Flex flex={1} justifyContent="flex-end" textAlign="right">
        Correção monetária
      </Flex>
      {/* <Flex flex={1} justifyContent="flex-end">
        Honorários
      </Flex> */}
      <Flex flex={1} justifyContent="flex-end">
        Total
      </Flex>
    </>
  );
}

export default TableHeaderRow;
